import React from 'react'

export const WITHDRAWAL_TIPS = {
  month: `用户你好，平台正在推进服务升级，需要迁移到其他品牌进行运营，将为您带来更好的体验。6月1日之前的金额仍然在派享云提现，6月1日及之后的金额到新平台提现。`,
  week: (
    <div>
      <div>
        用户你好,平台正在推进服务升级,需要迁移到代运维平台进行运营,将为您带来更好的体验
      </div>
      <div>1、历史钱包余额请到新平台提现</div>
      <div>2、6月9日及之后的账单,请到新平台查看</div>
    </div>
  ),
}
